import type { ReactNode } from 'react';

// Eén keuze uit een handvol, als knoppen naast elkaar (.vht-seg). De gekozen knop
// draagt aria-pressed — daar hangt ook het uiterlijk aan, dus die twee kunnen niet
// uit elkaar lopen.

export interface SegmentedOption<T extends string> {
  value: T;
  label: ReactNode;
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  label,
  className,
}: {
  options: readonly SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  /** What the group chooses — read out by assistive tech. */
  label: string;
  className?: string;
}) {
  return (
    <div className={className ? `vht-seg ${className}` : 'vht-seg'} role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
